module.exports = __webpack_public_path__ + "assets/img/1.40061ef9.png";